<template>
	<CLoader :pConfigLoad="ConfigLoad">
        <template slot="BodyFormLoad">
			<div class="container-fluid">
				<form id="FormAgenda" role="form" method="post" autocomplete="off" onSubmit="return false">	

					<div class="row">
						<div class="col-12 col-sm-12 col-md-12 col-lg-12">
							<label for="cmp1">{{objCotizacion.TipoEvento.Etiqueta}}</label>
							<input type="text" v-model="objCotizacion.Nombres" id="cmp1" class="form-control form-control-sm" readonly>
						</div>
					</div>

					<div class="row">
						<div class="col-12 col-sm-12 col-md-4 col-lg-4">
							<label for="cmp2">Folio</label>
							<input type="text" v-model="objCotizacion.Folio" id="cmp2" class="form-control form-control-sm" readonly>
						</div>

						<div class="col-12 col-sm-12 col-md-4 col-lg-4">
							<label for="cmp3">Tipo de Evento</label>
							<input type="text" v-model="objCotizacion.TipoEvento.Nombre" id="cmp3" class="form-control form-control-sm" readonly>
						</div>

						<div class="col-12 col-sm-12 col-md-4 col-lg-4">
							<label for="cmp4">Fecha Principal</label>
							<input type="text" v-model="objCotizacion.FechaBoda" id="cmp4" class="form-control form-control-sm" readonly>
						</div>
					</div>

					<div class="row">
						<div class="col-12 col-sm-12 col-md-6 col-lg-6">
							<label for="cmp5">Ejecutivo(a) Asignado</label>
							<input type="text" v-model="Vendedor" id="cmp5" class="form-control form-control-sm" readonly>
						</div>

						<div class="col-12 col-sm-12 col-md-6 col-lg-6">
							<label for="cmp6">Personal del Hotel Asignado</label>
							<input type="text" v-model="Contacto" id="cmp6" class="form-control form-control-sm" readonly>
						</div>
					</div>

					<div class="row">
						<div class="col-12 col-sm-12 col-md-12 col-lg-12">
							<label for="cmp7">Hotel / Empresa</label>
							<template v-if="objCotizacion.Agente">
								<input type="text" v-model="objCotizacion.Agente.NombreComercial" id="cmp7" class="form-control form-control-sm" readonly>
							</template>
							<template v-else>
								<input type="text" id="cmp7" class="form-control form-control-sm" readonly>
							</template>
						</div>
					</div>

					<h4 class="mt-3">Actividades</h4>

					<ul class="nav nav-tabs" id="myTab" role="tablist">
                        <li v-for="(item,index) in ListaEventos" :key="index" class="nav-item" role="presentation">
                            <button type="button" :class="['nav-link', index == 0 ? 'active': '']" :id="'home-tab'+index" data-bs-toggle="tab" :data-bs-target="'#home-tab-pane'+index" role="tab" :aria-controls="'home-tab-pane'+index" :aria-selected="index == 0 ? 'true':'false'">Evento {{index+1}}</button>
                        </li>
                    </ul>

					<div class="tab-content" id="myTabContentCal">
                        <div v-for="(item,index) in ListaEventos" :key="index" :class="['tab-pane fade scroll-ve',index == 0 ? 'show active': '']" :id="'home-tab-pane'+index" role="tabpanel" :aria-labelledby="'home-tab'+index" tabindex="0">
                            <div class="row">
								<div class="col-12 col-sm-12 col-md-12 col-lg-12">
									<label for="cmp8">Actividad</label>
									<input type="text" v-model="item.Evento" id="cmp8" class="form-control" readonly>
								</div>
							</div>

                            <div class="row">
								<div class="col-12 col-sm-12 col-md-4 col-lg-4">
									<label for="cmp9">Fecha Evento</label>
									<input type="text" v-model="item.FechaEvento" id="cmp9" class="form-control" readonly>
								</div>
								
								<div class="col-12 col-sm-12 col-md-4 col-lg-4">
									<label for="cmp10">Fecha Montaje</label>
									<input type="text" v-model="item.FechaMontaje" id="cmp10" class="form-control" readonly>
								</div>
								
								<div class="col-12 col-sm-12 col-md-4 col-lg-4">
									<label for="cmp11">Fecha DesMontaje</label>
									<input type="text" v-model="item.FechaDesmontaje" id="cmp11" class="form-control" readonly>
								</div>
							</div>

                            <div class="row">
								<div class="col-12 col-sm-12 col-md-4 col-lg-4">
									<label for="cmp12">Hora Evento</label>
									<input type="text" v-model="item.HoraEvento" id="cmp12" class="form-control" readonly>
								</div>

								<div class="col-12 col-sm-12 col-md-4 col-lg-4">
									<label for="cmp13">Hora Montaje</label>
									<input type="text" v-model="item.HoraMontaje" id="cmp13" class="form-control" readonly>
								</div>

								<div class="col-12 col-sm-12 col-md-4 col-lg-4">
									<label for="cmp14">Hora DesMontaje</label>
									<input type="text" v-model="item.HoraDesMontaje" id="cmp14" class="form-control" readonly>
								</div>
							</div>

							<div class="row">
								<div class="col-12 col-sm-12 col-md-6 col-lg-6">
									<label for="cmp15">Locación</label>
									<input type="text" v-model="item.Locacion" id="cmp15" class="form-control" readonly>
								</div>

								<div class="col-12 col-sm-12 col-md-6 col-lg-6">
									<label for="cmp16">Back Up</label>
									<input type="text" v-model="item.BackUp" id="cmp16" class="form-control" readonly>
								</div>
							</div>

							<div class="row">
								<div class="col-12 col-sm-12 col-md-12 col-lg-12">
									<label for="cmp17">Descripción</label>
									<textarea  v-model="item.Evento" id="cmp17" class="form-control" rows="2" readonly></textarea>
								</div>
							</div>

							<h5 class="mt-3">Detalle</h5>

							<div class="row pt-2">
								<div class="col-12 col-sm-12 col-md-12 col-lg-12">
									<div class="table-responsive pb-0">
										<table class="table mb-0">
											<thead>
												<tr>
													<th width="10%" :class="ClassTr">#</th>
													<th width="25%" :class="'text-uppercase '+ClassTr">Imagen</th>
													<th width="65%" :class="'text-uppercase '+ClassTr">Descripción</th>
												</tr>
											</thead>
											<tbody>
												<tr v-for="(list,index2) in item.Elementos" :key="index2">
													<td>{{index2+1}}</td>
													<td><img :src="RutaFile+list.UrlImagen+list.Nomimagen" width="100"></td>
													<td>{{list.Descripcion}}</td>
												</tr>
												<CSinRegistros :pContIF="item.Elementos.length" :pColspan="3"></CSinRegistros>
											</tbody>
										</table>
									</div>
								</div>
							</div>

						</div><!-- fin del tab -->
					</div>

					<!-- <pre>
						{{objCotizacion}}
					</pre> -->				
					<br>
					
				</form>
			</div>
		</template>
	</CLoader>
</template>

<script>
import moment from 'moment';

export default {
    name: 'FormResumen',
    props: ['poBtnSave'],
    components:{
    },
    data() {
        return {
			ConfigLoad:{
                ShowLoader: true,
                ClassLoad: false,
            },
            objCotizacion: {
				IdCotizacion: 0,
				IdCliente: 0,
				IdUsuario: 0,
				IdVendedor: 0,
				IdAgente: 0,
				IdContacto: 0,
				TipoBoda: 0,
				Folio: '',
				Estatus: '',
				TotalGlobal: '',
				FechaBoda: '',
				TotalGlobalPaqt: '',
				Nombres: '',
				Agente: {},
				TipoEvento: {},
            },
            errorvalidacion: [],
			Emit: this.poBtnSave.EmitSeccion,
			Vendedor: '',
			Contacto: '',
			ListaEventos: [],
			RutaFile: '',
			ClassTr: 'text-green-black text-xxs font-weight-bolder opacity-7',
        }
    },
    methods :
    {
		Recuperar()
        {
            this.$http.get(
                "calendarioResumen/"+this.objCotizacion.IdCotizacion
            ).then((res) => {
                this.objCotizacion = res.data.data;
				this.Vendedor = res.data.vendedor;
				this.Contacto = res.data.contacto;
				this.ListaEventos = res.data.eventos;

            }).finally(()=>{
                this.ConfigLoad.ShowLoader = false;
            });
        },
        Limpiar()
        {
            this.objCotizacion = {
				IdCotizacion: 0,
				IdCliente: 0,
				IdUsuario: 0,
				IdVendedor: 0,
				IdAgente: 0,
				IdContacto: 0,
				TipoBoda: 0,
				Folio: '',
				Estatus: '',
				TotalGlobal: '',
				FechaBoda: '',
				TotalGlobalPaqt: '',
				Nombres: '',
				Agente: {},
				TipoEvento: {},
			};

            this.errorvalidacion = [];
        },
		GetUlrRutas()
		{
			this.$http.get(
                "solicitudGetRutas/"
            ).then((res) => {
                this.RutaFile = res.data.RutaGaleria;
                //this.RutaAnexada = res.data.RutaAnexada;
                //this.RutaTemporal = res.data.RutaTemporal;

            }).finally(()=>{
            });
		},
		ValidarHoras(cmp)
		{
			let Hini = this.objAgenda.HoraIni;
			let Hfin = this.objAgenda.HoraFin;
			let FechaTransform = moment(new Date()).format('YYYY-MM-DD');

			if(Hini!=''){
				Hini = new Date(FechaTransform+' '+Hini+':00');
			}

			if(Hfin!=''){
				Hfin = (Hfin == '00:00')?'23:59':Hfin;
				Hfin = new Date(FechaTransform+' '+Hfin+':00');
			}

			if(Hini!='' && Hfin!='')
			{
				if(Hfin<=Hini)
				{
					this.$toast.warning('La hora final debe ser mayor a la hora inicial');
					if(cmp == 'HI'){
						this.objAgenda.HoraIni = '';
					}
					else{
						this.objAgenda.HoraFin = '';
					}
					return false;
				}
			}
		}
    },
    created() {
		this.poBtnSave.Toast = 0;

        this.bus.$off('Recovery_'+this.Emit);
        this.bus.$on('Recovery_'+this.Emit,(Id,obj)=>
        {
            this.ConfigLoad.ShowLoader = true;    
            this.poBtnSave.DisableBtn = false;

            this.bus.$off('Save_'+this.Emit);
            this.bus.$on('Save_'+this.Emit,()=>
            {
                this.Guardar();
            });
            this.Limpiar();
			this.GetUlrRutas();
                
            if (Id!='') 
            {
                this.objCotizacion.IdCotizacion = Id;
                this.Recuperar();
            }
            else
            {
                this.ConfigLoad.ShowLoader = false;
            }
        });
    }
}
</script>
